<template>
  <v-container align-start>
    <div class="section_inner text-center pt-5">
      <v-row v-show="fazeOne">
        <v-col>
          <h3 class="display-20 primary--text">
            חידוש הרישום לסוכן החכם הושלם בהצלחה!
          </h3>
          <p class="display-18">עדכונים לגבי משרות חדשות יישלחו לכתובת:</p>
          <p>
            <span class="email display-18 px-2">{{ userEmail }}</span>
          </p>
          <p>
            ניתן לערוך את הגדרות הסוכן החכם בכל עת באמצעות הלינק
            <br />
            שבתחתית האימייל או באמצעות כניסה לאיזור האישי.
          </p>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SeoOptimization from '@/components/mixins/SeoOptimization';
import CurrentUser from '@/components/mixins/CurrentUser';
import { ACTIVATE_SMART_ALERTS } from '@/lib/api.js';

export default {
  mixins: [SeoOptimization, CurrentUser],
  //  middleware: 'personalPage',
  layout: 'innerPage',
  name: 'activatesmartalertsPage',
  data() {
    return {
      loading: false,
      completedMessage: null,
      fazeOne: true,
      userEmail: null,
    };
  },

  mounted() {
    if (this.CurrentUser) {
      this.userEmail = this.CurrentUser.Email;
    }
  },

  async asyncData(context) {
    const { query } = context.route;
    const { sct, ref, dtt, utm_source } = query;

    try {
      let { data } = await context.$axios.get(`${ACTIVATE_SMART_ALERTS}`, {
        params: {
          sct: sct,
          ref: ref,
          dtt: dtt,
          utm_source: utm_source,
        },
      });

      if (data.IsError) {
        throw data.Errors;
      }

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo;
        return context.redirect(307, redirectUrl);
      }
      return {
        MessageToUser: data.MessageToUser,
        QueryString: data.QueryString,
        SendCVSummary: data.SendCVSummary,
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          breadcrumbs: data.SEO.BreadCrumbs.Keys,
        },
      };
    } catch (e) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'sendcvsummaryremove error page ' + e,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.email {
  background: $primary;
  color: #fff;
}
</style>
